<template>
  <div class="bookings">
    <page-header
      title="Shipping"
      breadcrumb="Dashboard > Operations > Bookings "
    />

    <div class="table-header mt-16">
      <div class="flex items-center">
        <div class="mr-2 filter">
          <svg
            width="12"
            height="18"
            viewBox="0 0 12 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.9841 1.99255C6.9841 1.44027 7.43181 0.992554 7.9841 0.992554C8.34149 0.992554 8.65509 1.18004 8.83192 1.46202L11.5195 4.14964C11.9101 4.54016 11.9101 5.17333 11.5195 5.56385C11.129 5.95438 10.4958 5.95438 10.1053 5.56385L8.9841 4.44263V11.9926C8.9841 12.5448 8.53638 12.9926 7.9841 12.9926C7.43181 12.9926 6.9841 12.5448 6.9841 11.9926V2.042C6.98397 2.03288 6.98397 2.02376 6.9841 2.01464V1.99255Z"
              fill="#10233E"
            />
            <path
              d="M5.01589 16.0074C5.01589 16.5597 4.56818 17.0074 4.01589 17.0074C3.6585 17.0074 3.3449 16.82 3.16807 16.538L0.480454 13.8504C0.08993 13.4598 0.08993 12.8267 0.480454 12.4361C0.870978 12.0456 1.50414 12.0456 1.89467 12.4361L3.01589 13.5574V6.00745C3.01589 5.45516 3.46361 5.00745 4.01589 5.00745C4.56818 5.00745 5.01589 5.45516 5.01589 6.00745V15.958C5.01602 15.9671 5.01602 15.9762 5.01589 15.9854V16.0074Z"
              fill="#10233E"
            />
          </svg>
        </div>
        <div class="table__search-input-wrapper">
          <span class="pr-2 opacity-50"><search-icon /> </span>

          <input
            type="text"
            class="table__search-input"
            placeholder="Search..."
          />

          <svg
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 1.99992C0 1.35559 0.522334 0.833252 1.16667 0.833252H12.8333C13.4777 0.833252 14 1.35559 14 1.99992C14 2.64425 13.4777 3.16659 12.8333 3.16659H1.16667C0.522334 3.16659 0 2.64425 0 1.99992Z"
              fill="#10233E"
            />
            <path
              d="M2.33333 6.66658C2.33333 6.02225 2.85567 5.49992 3.5 5.49992H10.5C11.1443 5.49992 11.6667 6.02225 11.6667 6.66658C11.6667 7.31092 11.1443 7.83325 10.5 7.83325H3.5C2.85567 7.83325 2.33333 7.31092 2.33333 6.66658Z"
              fill="#10233E"
            />
            <path
              d="M5.83333 10.1666C5.189 10.1666 4.66667 10.6889 4.66667 11.3333C4.66667 11.9776 5.189 12.4999 5.83333 12.4999H8.16667C8.811 12.4999 9.33333 11.9776 9.33333 11.3333C9.33333 10.6889 8.811 10.1666 8.16667 10.1666H5.83333Z"
              fill="#10233E"
            />
          </svg>
        </div>
      </div>

      <div class="date-picker flex items-center justify-center">
        <span class="text-sm pr-2">Show data from:</span>
        <el-date-picker v-model="date" type="date" placeholder="Pick a day">
        </el-date-picker>
      </div>
    </div>

    <div class="table-wrapper" id="table-wrapper">
      <table class="custom-table responsive-table">
        <thead>
          <tr>
            <th><input type="checkbox" class="checkbox" /></th>
            <th class="shipping-ref-col">SHIPPING REF.</th>
            <th class="shipping-option-col">
              BOOKING CHANNEL
            </th>
            <th class="width-md">SHIPPER</th>
            <th class="width-md">CONSIGNEE</th>
            <th class="width-xs">PICK-UP DATE</th>
            <th class="width-xs">EST. DROP DATE</th>
            <th class="width-sm" v-if="!removedTableData.includes('routing')">
              ROUTING
            </th>
            <th class="width-xs" v-if="!removedTableData.includes('handOff')">
              HAND-OFF
            </th>
            <th
              class="width-sm"
              v-if="!removedTableData.includes('receiveFrom')"
            >
              RECEIVE FROM
            </th>
            <th class="width-sm" v-if="!removedTableData.includes('deliverTo')">
              DELIVER TO
            </th>
            <th class="width-xs" v-if="!removedTableData.includes('distance')">
              DISTANCE (Km)
            </th>
            <th class="width-xs" v-if="!removedTableData.includes('weight')">
              WEIGHT(Kg)
            </th>
            <th class="width-sm" v-if="!removedTableData.includes('income')">
              INCOME
            </th>
            <th class="width-sm" v-if="!removedTableData.includes('fleet')">
              FLEET
            </th>
            <th class="width-sm" v-if="!removedTableData.includes('driver')">
              DRIVER
            </th>
            <th class="d-flex align-items-center relative">
              STATUS
            </th>
            <th class="relative" tabindex="-1" @blur="isTableFilter = false">
              <span
                class="cursor-pointer"
                @click="isTableFilter = !isTableFilter"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.7">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                      fill="#383F51"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                      fill="#383F51"
                    />
                  </g></svg
              ></span>
              <div v-if="isTableFilter">
                <table-filter @update-table="updateTableData($event)" />
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="n in 10" :key="n" class="cursor-pointer">
            <td><input type="checkbox" class="checkbox" /></td>
            <td><span>MX000218</span><span>Cloudenly</span></td>
            <td>3PL GIG Logistics</td>
            <td>
              <span>Emondi Ibikunle</span
              ><span>126 Freedom Way, Lekki Phase 1, Lagos, Nigeria.</span>
            </td>
            <td>
              <span>Ada Orakwue</span
              ><span>12 Odenigbo Road, Nsukka, Enugu, Nigeria</span>
            </td>
            <td><span>13/02/2021</span> <span>10:00 AM</span></td>
            <td><span>15/02/2021</span> <span>12:22 PM</span></td>
            <td v-if="!removedTableData.includes('routing')">
              Lekki - Jibowu- Enugu
            </td>
            <td v-if="!removedTableData.includes('handOff')">2</td>
            <td v-if="!removedTableData.includes('receiveFrom')">Customer</td>
            <td v-if="!removedTableData.includes('deliverTo')">Ifex, Jibowu</td>
            <td v-if="!removedTableData.includes('distance')">42</td>
            <td v-if="!removedTableData.includes('weight')">200</td>
            <td v-if="!removedTableData.includes('income')">200,000.35</td>
            <td v-if="!removedTableData.includes('fleet')">
              <span>AJ4521H</span>
              <span class="flex"
                ><svg
                  width="8"
                  height="8"
                  viewBox="0 0 8 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="4" cy="4" r="4" fill="#09B78A" />
                </svg>
                Dispatched</span
              >
            </td>
            <td v-if="!removedTableData.includes('driver')">Tunde</td>
            <td><span class="booking-status">Cancelled</span></td>
            <td>
              <span><vertical-ellipsis /></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination-control />

    <div class="flex">
      <div class="financial-summary ml-auto">
        <div class="header">
          <p class="text-sm">Financial Summary of Table above</p>
        </div>
        <hr />
        <hr />
        <div class="total-income">
          <p>Total Amount: <span>₦2,670,800.80</span></p>
        </div>
        <div class="gross-income">
          <p>GROSS INCOME: <span>₦2,670,800.80</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import PaginationControl from "@/components/UI/NewPagination";
import TableFilter from "./TableFilter";
// import DragIcon from "./svgs/FilterDragIcon";
// import ViewIcon from "./svgs/ViewIcon";

export default {
  components: {
    PageHeader,
    PaginationControl,
    TableFilter,
  },
  data() {
    return {
      date: "",
      isTableFilter: false,
      removedTableData: [
        "routing",
        "handOff",
        "receiveFrom",
        "deliverTo",
        "distance",
        "weight",
        "income",
        "fleet",
        "driver",
      ],
    };
  },
  watch: {
    isTableFilter() {
      let container = document.getElementById("table-wrapper");
      container.scrollLeft += 500;
    },
  },
  methods: {
    updateTableData(data) {
      let index = this.removedTableData.indexOf(data);
      if (index >= 0) {
        this.removedTableData.splice(index, 1);
      } else {
        this.removedTableData.push(data);
      }
      this.isTableFilter = false;
      this.scrollLeft();
    },
    scrollLeft() {
      let container = document.getElementById("table-wrapper");
      console.log(container.scrollLeft);
      container.scrollLeft += 10000;
      // console.log(container.scrollLeft);
    },
  },
};
</script>

<style lang="scss" scoped>
#table-wrapper {
  margin: 2rem 0;
  overflow-x: auto;
}

.table-wrapper,
.table-wrapper .custom-table {
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg);
}

/* width */
.table-wrapper::-webkit-scrollbar {
  cursor: pointer;
  width: 5px;
  height: 9px;
}

/* Track */
.table-wrapper::-webkit-scrollbar-track {
  background: #c4c4c4;
}

/* Handle */
.table-wrapper::-webkit-scrollbar-thumb {
  background: #fab427;
  width: 5px;
  border-radius: 20px;
}
.custom-table {
  margin: 0;
}
.booking-categories {
  display: flex;
}
.booking-category {
  color: #383f51;
  opacity: 0.7;
  display: flex;
  align-items: center;
  margin-right: 1rem;
  &.active {
    font-weight: 500;
    opacity: 1;
    .booking-category-amount {
      background: #10233e;
    }
  }
  .booking-category-amount {
    background: #8a97a5;
    border-radius: 10px;
    color: #ffffff;
    margin-left: 1rem;
    padding: 0.25rem 0.75rem;
  }
}
.table-header {
  justify-content: space-between;
}

.booking-categories {
  display: flex;
  align-items: center;
  margin: 2rem 0 4rem 0;
}

th {
  color: rgba(25, 48, 77, 0.7);
  font-weight: 500;
}
.checkbox {
  display: initial;
  width: 1rem;
  height: 1rem;
}

th {
  padding: 0.75rem;
}
.width-md {
  min-width: 14rem;
}
.width-sm {
  min-width: 10rem;
}
.width-xs {
  min-width: 6rem;
}
td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
  border-radius: 2px;
  padding: 0.75rem;
  vertical-align: top;

  span {
    display: block;
  }
  span:last-of-type {
    font-weight: normal;
    color: #10233e;
    opacity: 0.6;
    padding-top: 0.25rem;
    font-size: 0.8rem;
  }
}
.shipping-option-col {
  width: 16%;
}
.shipping-ref-col {
  width: 13%;
}
.booking-status {
  background: #fae5e7;
  color: #d72638 !important;
  border-radius: 10px;
  padding: 0.5rem;
  font-weight: 500 !important;
  opacity: 1 !important;
}
table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
.table__search-input-wrapper {
  background: #f7fafd;
  width: 20rem;
  border-radius: 5px;
}
.financial-summary {
  background: #ffffff;
  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 5px;

  .header {
    padding: 0.5rem 2rem;
  }

  width: 25rem;
}
.total-income {
  padding: 1rem 2rem;
}
.gross-income {
  background: var(--primaryblue);
  color: #ffffff;
  padding: 1rem 2rem;
}
.filter {
  background: #f7fafd;
  border-radius: 5px;
  padding: 0.75rem 1rem;
}
</style>
